module.exports = __webpack_public_path__ + "media/images/recrutare/favicon-a7d7ef2f144b648489b0730ce53872f4.png";